
import React from 'react';
import Button from '@mui/material/Button';
import {CREATEACCOUNT_TEXT} from '../../../../constants/Admin/adminConstants';
import './createaccountbutton.scss';

const CreateAccountButton = ({ onClick, disable })=> {

	return(
			<div className='create-account-cta'>
				<Button variant='contained'
						color='primary' onClick={onClick} disabled={disable}
						type='submit'>	
						{CREATEACCOUNT_TEXT}
				</Button>
			</div>
	);
}

 export default CreateAccountButton;
